import { Component } from '@angular/core';

@Component({
  templateUrl: './logout.page.html',
})
/**
 * Log out page to allow token clearing
 */
export class LogoutPage {}
